import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2fe9ae9a")

_pushScopeId("data-v-2fe9ae9a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Riepilogo richieste")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "calendar_section" }
const _hoisted_5 = {
  key: 0,
  class: "calendar_day_filter"
}
const _hoisted_6 = { class: "calendar_day_filter_label" }
const _hoisted_7 = { class: "search_container" }
const _hoisted_8 = { class: "filters_container" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Tutte le tipologie")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Tutti gli stati")
const _hoisted_11 = {
  key: 0,
  class: "no_documents_container_detail"
}
const _hoisted_12 = { class: "no_documents" }
const _hoisted_13 = { class: "richieste_container" }
const _hoisted_14 = { class: "richiesta_info" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "subtitle" }
const _hoisted_17 = { class: "date" }
const _hoisted_18 = {
  key: 0,
  class: "orari"
}
const _hoisted_19 = {
  key: 0,
  class: "note"
}
const _hoisted_20 = {
  key: 0,
  class: "richiesta_actions"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_select_option = _resolveComponent("ion-select-option")
  const _component_ion_select = _resolveComponent("ion-select")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadRichieste()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_Calendar, {
                    value: $setup.calendarMonth,
                    attributes: $setup.calendarAttributes,
                    onDayclick: $setup.dayClicked,
                    "is-expanded": "",
                    class: "calendar_container"
                  }, null, 8, ["value", "attributes", "onDayclick"]),
                  ($setup.selectedCalendarDay)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode("span", _hoisted_6, _toDisplayString($setup.calendarSelectedLabel), 1),
                        _createVNode("button", {
                          type: "button",
                          class: "calendar_day_filter_clear",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.clearCalendarDayFilter && $setup.clearCalendarDayFilter(...args)))
                        }, " Tutte le date ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_ion_input, {
                    type: "text",
                    "clear-input": "",
                    modelValue: $setup.searchQuery,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.searchQuery = $event)),
                    placeholder: "Cerca richiesta",
                    class: "search_richieste_input"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_ion_select, {
                    modelValue: $setup.selectedTipologiaFilter,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.selectedTipologiaFilter = $event)),
                    interface: "action-sheet",
                    "cancel-text": "Annulla",
                    "ok-text": "Conferma",
                    placeholder: "Tutte le tipologie",
                    class: "filter_select"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_select_option, { value: "" }, {
                        default: _withId(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.tipologiaFilterOptions, (opt) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: `tipologia-${opt.id}`,
                          value: opt.id
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(opt.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ion_select, {
                    modelValue: $setup.selectedStatoFilter,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.selectedStatoFilter = $event)),
                    interface: "action-sheet",
                    "cancel-text": "Annulla",
                    "ok-text": "Conferma",
                    placeholder: "Tutti gli stati",
                    class: "filter_select"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_select_option, { value: "" }, {
                        default: _withId(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.statoFilterOptions, (opt) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: `stato-${opt.id}`,
                          value: opt.id
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(opt.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                ($setup.richiesteToShow.length == 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, _toDisplayString($setup.richieste.length === 0
                                ? "Nessuna richiesta da gestire"
                                : $setup.selectedCalendarDay
                                  ? "Nessuna richiesta per questo giorno"
                                  : "Nessun risultato"), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_13, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.richiesteToShow, (richiesta) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "richiesta",
                      key: richiesta.richieste_id
                    }, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("div", _hoisted_15, _toDisplayString(richiesta.richieste_tipologia_value || richiesta.richieste_tipologia), 1),
                        _createVNode("div", _hoisted_16, _toDisplayString(richiesta.dipendenti_nome) + " " + _toDisplayString(richiesta.dipendenti_cognome), 1),
                        _createVNode("div", _hoisted_17, [
                          _createTextVNode(_toDisplayString($setup.dataRichiesta(richiesta.richieste_dal, richiesta.richieste_al)) + " ", 1),
                          ($setup.orarioRichiesta(richiesta))
                            ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString($setup.orarioRichiesta(richiesta)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (richiesta.richieste_note)
                          ? (_openBlock(), _createBlock("div", _hoisted_19, " Note: " + _toDisplayString(richiesta.richieste_note), 1))
                          : _createCommentVNode("", true)
                      ]),
                      ($setup.isRichiestaGestibile(richiesta))
                        ? (_openBlock(), _createBlock("div", _hoisted_20, [
                            _createVNode("button", {
                              size: "small",
                              class: "btn_change_status btn_approve",
                              onClick: ($event: any) => ($setup.approveRichiesta(richiesta.richieste_id)),
                              disabled: $setup.processing
                            }, [
                              _createVNode(_component_ion_icon, {
                                icon: $setup.checkmark,
                                slot: "icon-only"
                              }, null, 8, ["icon"])
                            ], 8, ["onClick", "disabled"]),
                            _createVNode("button", {
                              size: "small",
                              class: "btn_change_status btn_decline",
                              onClick: ($event: any) => ($setup.rejectRichiesta(richiesta.richieste_id)),
                              disabled: $setup.processing
                            }, [
                              _createVNode(_component_ion_icon, {
                                icon: $setup.close,
                                slot: "icon-only"
                              }, null, 8, ["icon"])
                            ], 8, ["onClick", "disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})